// extracted by mini-css-extract-plugin
export default {"divider":"uploadfilepage_divider__1I0SQ"};